/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export function getCookie(cookieName: string) {
  // Split the cookie string into an array of individual cookies
  const cookies = document.cookie.split(';');

  // Loop through the cookies to find the one with the specified name
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim(); // Remove leading and trailing spaces

    // Check if this cookie starts with the name you're looking for
    if (cookie.indexOf(`${cookieName}=`) === 0) {
      // Extract and return the cookie's value
      return cookie.substring(cookieName.length + 1);
    }
  }

  // If the cookie is not found, return null
  return null;
}
